import angular from 'angular';

angular.module('digitalPayments').factory('cashlogy', cashlogy);

cashlogy.$inject = ["$mdDialog", "$translate", "$filter", "$interval", "checkManager", "cashlogyDriver"];

function cashlogy($mdDialog, $translate, $filter, $interval, checkManager, cashlogyDriver) {
    cashlogyController.$inject = ["$scope", "amount", "paymentMethod", "transactionType"];

    function cashlogyController($scope, amount, paymentMethod, transactionType) {
        $scope.trSt = null;
        $scope.transactionType = transactionType;
        $scope.inProgress = true;
        $scope.message = $translate.instant('DIGITAL_PAYMENTS.CASHDRAWERS.CONNECTING', { drawer: 'Cashlogy'});

        $scope.showConfirm = function() {
            return $scope.changeNotGiven || (transactionType === 'DEPOSIT' && !$scope.inProgress);
        };

        $scope.getStatusUpdate = function() {
            var status = cashlogyDriver.getStatus();

            switch(status) {
                case 'UNINITIALIZED':
                    $scope.inProgress = true;
                    $scope.message = $translate.instant('DIGITAL_PAYMENTS.CASHDRAWERS.CONNECTING', { drawer: 'Cashlogy'});
                break;
                case 'INITIALIZING':
                    $scope.inProgress = true;
                    $scope.message = $translate.instant('DIGITAL_PAYMENTS.CASHDRAWERS.INITIALIZING', { drawer: 'Cashlogy'});
                break;
                case 'PAYING':
                    $scope.inProgress = false;
                    $scope.message = $translate.instant('DIGITAL_PAYMENTS.CASHDRAWERS.PAYING', { drawer: 'Cashlogy'});
                break;
            }
        };

        $scope.close = (confirmTransaction) => {
            if($scope.transactionType === 'DEPOSIT') {
                cashlogyDriver.stopDeposit();
            } else if($scope.trSt.paid >= amount || confirmTransaction) {
                $mdDialog.hide($scope.trSt);
            } else {
                $mdDialog.cancel('CANCELED');
            }
        };

        $scope.getStatusUpdate();

        var statusUpdate = $interval($scope.getStatusUpdate, 1000);

        try {
            cashlogyDriver.initialize(paymentMethod.schema_name, { transactionType: transactionType });

            cashlogyDriver.performPayment(amount).then(function(result) {
                if(transactionType === 'DEPOSIT' || !result.changeNotGiven) {
                    return $mdDialog.hide(result);
                }

                $scope.trSt = result;
                $scope.message = $translate.instant('DIGITAL_PAYMENTS.CASHDRAWERS.CHANGE_NOT_GIVEN_ERROR');
                $scope.changeNotGiven = true;

                $scope.$applyAsync();
            }, function(error) {
                $mdDialog.cancel(error);
            }).finally(function() {
                $interval.cancel(statusUpdate);
            });
        } catch(e) {
            throw e;
        }
    }

    var cashlogy = {
        getPaymentReceipt(paymentMethod) {
            if(!paymentMethod.payment_data) {
                return '';
            }

            try {
                const transaction = JSON.parse(paymentMethod.payment_data);

                const receiptTail = [
                    "Dettaglio pagamento",
                    "",
                    `Da pagare ${$filter('sclCurrency')(transaction.toPay).padStart(22, ' ')}`,
                    `Pagato ${$filter('sclCurrency')(transaction.paid).padStart(25, ' ')}`,
                    `Resto erogato ${$filter('sclCurrency')(transaction.changeGiven).padStart(18, ' ')}`,
                    `Resto non erogato ${$filter('sclCurrency')(transaction.changeNotGiven).padStart(14, ' ')}`,
                ];

                return receiptTail.join('\n');
            } catch(err) {
                return '';
            }
        },
        payment: function(amount, options, transactionType) {
            let paymentMethod = options.paymentMethod;

            if (!paymentMethod.schema_name) {
                return Promise.reject($translate.instant('DIGITAL_PAYMENTS.CASHDRAWERS.SCHEMA_NAME_NOT_FOUND', { drawer: 'Cashlogy' }));
            }

            return $mdDialog.show({
                controller: cashlogyController,
                template: require('./cashlogy.html'),
                locals: {
                    amount: amount,
                    paymentMethod: structuredClone(paymentMethod),
                    transactionType: transactionType
                }
            }).then(function(transaction) {
                let amountOverride;

                if (checkManager.getPreference('cashregister.register_cashdrawers_paid_amount')) {
                    amountOverride = transaction.paid;

                    if (amount < 0 && amountOverride > 0) {
                        amountOverride = -amountOverride;
                    }
                }

                return {
                    ...(amountOverride ? { amount: amountOverride } : {}),
                    payment_data: JSON.stringify(transaction),
                    unclaimed: false,
                };
            }, function(error) {
                throw 'CASHLOGY.' + error;
            });
        },
        deposit: (amount, options) => cashlogy.payment(amount, options, 'DEPOSIT'),
    };

    return cashlogy;
}